import { render, staticRenderFns } from "./BusinessHoursSetting.vue?vue&type=template&id=5c57a890&scoped=true"
import script from "./BusinessHoursSetting.vue?vue&type=script&lang=js"
export * from "./BusinessHoursSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c57a890",
  null
  
)

export default component.exports